/// <amd-module name="Checks/ChecksOverview/ChecksActions" />
import { Action } from "VSS/Reflux/Action";
import * as PipelineChecksContracts from "Checks/Client/Contracts/PipelinesChecks";

export class ChecksActions {

    public static getInstance(): ChecksActions {
        if (!this._instance) {
            this._instance = new ChecksActions();
        }
        return this._instance;
    }

    public addCheck = new Action<PipelineChecksContracts.CheckConfigurationData>();
    public deleteCheck = new Action<number>();
    public updateCheck = new Action<PipelineChecksContracts.CheckConfigurationData>();
    public filterChecks = new Action<string>();

    private static _instance: ChecksActions;
}
